
import { Component, Input, OnInit } from '@angular/core';
import { GlobalMessageEntities, GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { GlobalMessageComponent } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
  selector: 'cx-global-message',
  templateUrl: './custom-global-message.component.html'
})
export class CustomGlobalMessageComponent extends GlobalMessageComponent implements OnInit {
  @Input() isInnerHtmlEnable: boolean = false;
  constructor(
    globalMessageService: GlobalMessageService
  ) {
    super(globalMessageService);
  }

  messages$!: Observable<GlobalMessageEntities>;
  messageType: typeof GlobalMessageType = GlobalMessageType;


  ngOnInit(): void {
    this.messages$ = this.globalMessageService.get();
  }

  clear(type: GlobalMessageType, index: number): void {
    this.globalMessageService.remove(type, index);
  }

}
